import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------category-listing--------------------------
export const brandListApi = async (data) => {
  const endPoint = `/admin/brands?${new URLSearchParams({
    ...data,
  })}`;

  return await axios.get(endPoint, setJwtToken());
};

// ---------------------add Brands-listing--------------------------
export const addBrandApi = async (data) => {
  const endPoint = `/admin/brands`;

  return await axios.post(endPoint, data, setJwtToken());
};

// ---------fetch selected banner

export const getSelectedBrand = async (id) => {
  const endPoint = `/admin/brands/${id}`;

  return await axios.get(endPoint, setJwtToken());
};

// ---------------------Edit Brands-listing--------------------------
export const editBrandApi = async ({ data, brandIdState }) => {
  const endPoint = `/admin/brands/${brandIdState}`;

  return await axios.put(endPoint, data, setJwtToken());
};

// ---------Delete Brand selected

export const deleteSelectedBrand = async (id) => {
  const endPoint = `/admin/brands/${id}`;

  return await axios.delete(endPoint, setJwtToken());
};
